import React from 'react'
import { HelpCircle } from 'lucide-react'
import { Button } from '@/components/ui/Button'

interface HelpButtonProps {
  onClick: () => void
  className?: string
}

export function HelpButton({ onClick, className = '' }: HelpButtonProps) {
  return (
    <Button
      onClick={onClick}
      variant="ghost"
      size="icon"
      className={`rounded-full hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors ${className}`}
      aria-label="Show help tour"
      title="Show help tour"
    >
      <HelpCircle className="w-5 h-5 text-blue-600 dark:text-blue-400" />
    </Button>
  )
}

